import React from 'react';
import { motion } from 'framer-motion';
import { Image as ImageIcon } from 'lucide-react';
export function Courses() {
  const courses = [{
    title: 'La Ruta Digital',
    description: 'Descubre tu camino digital y entiende por dónde empezar.',
    tag: 'Principiante',
    image: 'https://cdn.magicpatterns.com/uploads/oNbgXRJzjHc5pb3EmR4T2c/Ruta_Digital.png'
  }, {
    title: 'Impulso Interno',
    description: 'Cambia tu mentalidad y prepara tu vida para ejecutar con claridad.',
    tag: 'Mentalidad',
    image: 'https://cdn.magicpatterns.com/uploads/8c8hB4DS8F6WuvRS6Ccz64/Impulso_Interno.png'
  }, {
    title: 'De Cero a Estratega',
    description: 'Crea tu primer plan de marketing con estructura e inteligencia artificial.',
    tag: 'Estrategia',
    image: 'https://cdn.magicpatterns.com/uploads/mSnH6wcsfvmzsr8ira7YNo/De_Cero_a_Estratega.png'
  }, {
    title: 'De 0 a tu primera Campaña',
    description: 'Aprende a crear campañas publicitarias desde cero.',
    tag: 'Publicidad',
    image: 'https://cdn.magicpatterns.com/uploads/jP4BmNjcGfh949iS67VGPH/De_0_a_tu_Primera_Campana.png'
  }, {
    title: 'Curso Meta Pro',
    description: 'Domina campañas avanzadas en Meta Ads y escala con datos.',
    tag: 'Meta Ads',
    image: 'https://cdn.magicpatterns.com/uploads/er6Tbs46wvZ93gmSA2vPiY/Curso_Meta_Pro.png'
  }, {
    title: 'CRM para Principiantes',
    description: 'Organiza contactos, procesos y seguimiento comercial desde el inicio.',
    tag: 'Automatización',
    image: 'https://cdn.magicpatterns.com/uploads/ox5Eb99GNCzBHG8hR1ntP6/Curso_CRM_para_Principiantes.png'
  }];
  return <section id="cursos" className="py-12 lg:py-16 bg-white" data-id="element-55">
      <div className="container mx-auto px-4 md:px-6" data-id="element-56">
        <div className="text-center max-w-3xl mx-auto mb-8" data-id="element-57">
          <h2 className="text-3xl md:text-4xl font-bold text-link-dark mb-3" data-id="element-58">
            Cursos diseñados para llevarte paso a paso
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-4 max-w-5xl mx-auto" data-id="element-59">
          {courses.map((course, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="group bg-white rounded-xl border border-gray-200 overflow-hidden hover:shadow-md hover:border-link-blue/30 transition-all flex" data-id="element-60">
              {/* Thumbnail */}
              <div className="relative w-32 sm:w-40 flex-shrink-0 bg-link-light overflow-hidden" data-id="element-61">
                {course.image ? <img src={course.image} alt={course.title} className="w-full h-full object-cover" data-id="element-62" /> : <div className="w-full h-full flex flex-col items-center justify-center" data-id="element-63">
                    <ImageIcon size={20} className="text-link-blue/40" data-id="element-64" />
                  </div>}
              </div>

              {/* Content */}
              <div className="p-4 flex flex-col justify-center min-w-0 flex-grow" data-id="element-65">
                <div className="flex items-center gap-2 mb-1.5" data-id="element-66">
                  <span className="inline-block px-2 py-0.5 bg-link-light text-link-blue text-[10px] font-semibold rounded-full uppercase tracking-wide" data-id="element-67">
                    {course.tag}
                  </span>
                </div>
                <h3 className="text-base font-bold text-link-dark mb-1 leading-snug" data-id="element-68">
                  {course.title}
                </h3>
                <p className="text-gray-600 text-xs leading-relaxed line-clamp-2" data-id="element-69">
                  {course.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}